<template>
    <div class="mt-3">
        <div class="small text-muted" v-if="data_aplic">{{ $util.getFormatDate(data_aplic) }}</div>
        <table class="table table-sm table-hover small mb-0">
            <thead>
                <tr>
                    <th>Prescrito</th>
                    <th>Posologia</th>
                    <th>Qtde</th>
                    <th>Estoque</th>
                    <th>Apresentações</th>
                    <th v-if="data_aplic">Horários</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(rmi, ifx) in receita.flat_items" :key="ifx">
                    <td v-if="rmi.item">
                        <template v-if="rmi.item">
                            {{ rmi.item.search }}
                            <span class="badge badge-secondary">
                                #{{ rmi.id_medicamento }}
                            </span>
                        </template>
                    </td>
                    <td><span v-html="tratar_br(rmi.complemento)"></span></td>
                    <td>
                        {{ rmi.in_quantidade }}
                        {{ rmi.apresentacao ? rmi.apresentacao.search : '' }}
                    </td>
                    <td>
                        <template v-if="rmi.estoque_item">
                            {{ rmi.estoque_item ? rmi.estoque_item.search : ''}}
                            <span class="badge badge-secondary">
                                #{{ rmi.estoque_item.id_estoque_item }}
                            </span>
                            <span class="badge badge-primary ml-1" v-if="rmi.estoque_item.componentes_count">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                {{ rmi.estoque_item.componentes_count }}
                            </span>
                        </template>
                    </td>
                    <td>
                        <div>{{ rmi.quantidades_compra }}</div>
                        <div class="small text-muted" v-if="rmi.estoque_item && rmi.estoque_item.apresentacoes && rmi.estoque_item.apresentacoes.length">
                            {{ rmi.estoque_item.apresentacoes.map(item => ( item.in_quantidade + '' ) + rmi.estoque_item.st_unidade_estoque)
                                .join(', ') }}
                        </div>
                    </td>
                    <td v-if="data_aplic">
                        {{ tratar_horarios(rmi.js_prescricao_horarios).map(item => item.horario + ( item.status == 'A' ? '' : item.status) ).join(', ') }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ['receita', 'data_aplic'],

    methods: { 
        tratar_br (texto) { 
            if ( texto.slice(0,4).toLowerCase() == '<br>' ) { 
                return texto.slice(4);
            }

            return texto; 
        },

        tratar_horarios (horarios) { 
            if ( !horarios || !horarios.horarios ) { 
                return []; 
            }

            return horarios.horarios.filter(horario => { 
                return !this.data_aplic
                    || horario.hora.length < 15 
                    || ( this.data_aplic == horario.hora.slice(0,10) );
            }).map(horario => { 
                return { 
                    hora: horario.hora, 
                    status: horario.status,
                    horario: horario.hora.length > 10 ? horario.hora.slice(11,16) : horario.hora 
                };
            });
        }
    }
}
</script>
